import { render, staticRenderFns } from "./AppointmentCreatedToAssistant.vue?vue&type=template&id=c7d0b27a"
import script from "./AppointmentCreatedToAssistant.vue?vue&type=script&lang=js"
export * from "./AppointmentCreatedToAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports